import { useMemo } from "react";
import type { HeygenAvatarType, HeygenEngine } from "@yedalabs/schema";
import { getEngineCapabilities } from "../lib/engineCapabilities";
import type { AvatarLook } from "../types";

export const useEngineCapabilities = (
    look: AvatarLook | null | undefined,
    selectedEngine: HeygenEngine = "avatar_iv"
) => {
    return useMemo(() => {
        if (!look) {
            return {
                supportsIV: false,
                supportsV: false,
                supportsMotionPrompt: false,
                supportsExpressiveness: false,
                supportsArbitraryImage: false,
            };
        }
        return getEngineCapabilities(
            look.avatarType as HeygenAvatarType,
            (look.supportedEngines ?? []) as HeygenEngine[],
            selectedEngine
        );
    }, [look, selectedEngine]);
};
